<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Import" :toggleable="true" :collapsed="true" class="mb-3"
                    v-if="permission.includes('create')">
                    <Import @submit="getDataTable()" ref="import" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="salesman_code" header="Salesman Code">
                        <template #body="slotProps">
                            {{ slotProps.data.salesman_code }}
                        </template>
                    </Column>
                    <Column field="salesman_name" header="Salesman Name">
                        <template #body="slotProps">
                            {{ slotProps.data.salesman_name }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="ship_to_code" header="Ship To Code">
                        <template #body="slotProps">
                            {{ slotProps.data.ship_to_code }}
                        </template>
                    </Column>
                    <Column field="distributor_name" header="Distributor">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_name }}
                        </template>
                    </Column>
                    <Column field="user_code" header="User Code">
                        <template #body="slotProps">
                            {{ slotProps.data.user_code }}
                        </template>
                    </Column>
                    <Column field="user_name" header="User Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>


                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Error from "../../components/Error.vue";
import Import from "../../components/master/salesman/Import.vue";

export default {
    components: {
        Error: Error,
        Import: Import,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,
        };
    },
    mounted() {
        this.getDataTable();
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(["errors"]),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;
         
            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-salesman",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    
                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (ext == "xlsx") {
                this.loadingExcel = true;
            } else if (ext == "csv") {
                this.loadingCsv = true;
            }

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/master-salesman/export",
                responseType: "blob",
                params: {
                    ext: ext,
                },
            })
                .then((response) => {
                    let fileUrl = window.URL.createObjectURL(response.data);
                    let fileLink = document.createElement("a");

                    fileLink.href = fileUrl;

                    fileLink.setAttribute("download", "Master Salesman Export." + ext);

                    document.body.appendChild(fileLink);

                    fileLink.click();

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                })
                .catch((err) => {
                    console.log(err);

                    if (ext == "xlsx") {
                        this.loadingExcel = false;
                    } else if (ext == "csv") {
                        this.loadingCsv = false;
                    }
                });
        },
    },
};
</script>
